module.exports = __webpack_public_path__ + "static/media/ConsultSrtMsgImg.a1f58d69.png";